<mat-form-field>
  <mat-label [translate]="labelKey | translate"></mat-label>
  <mat-chip-grid #chipGrid>
    @for (item of selectedItems; track item[this.idField]) {
      <mat-chip-row (edited)="remove(item)" [editable]="true" [removable]="true" (removed)="remove(item)">
        {{ displayOption(item) }}
        <button matChipRemove type="button">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
    }
    <input
      #targetInput
      [placeholder]="'COMMON.TYPE_TO_SEARCH' | translate"
      [matChipInputFor]="chipGrid"
      (input)="filter(targetInput)"
      (focus)="filter(targetInput)"
      [matAutocomplete]="auto"
    />

    <mat-autocomplete #auto="matAutocomplete" [class]="panelClass" (optionSelected)="optionSelected($event, targetInput)" requireSelection>
      @for (item of filteredOptions; track item[this.idField]) {
        <mat-option [value]="item">
          {{ displayOption(item) }}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-chip-grid>
</mat-form-field>
